<template>
  <!-- 左右固定内容 -->
  <div class="side left">
    <img :src="leftBanner" alt="banner_left">
  </div>
  <div class="side right">
    <img :src="rightBanner" alt="banner_right">
  </div>
  <div class="container" style="background: #F2F2FF;">
    <b-container>
      <section class="mt-3">
        <div class="d-none d-lg-block">
          <img :src="banner_middle" alt="banner_top" style="width: 100%;height: auto;">
        </div>
        <div class="d-block d-lg-none">
          <img src="@/assets/picture/advertise/banner_top_h5.png" alt="banner_top_h5" style="width: 100%;height: auto;">
        </div>
      </section>
    </b-container>
    <b-container>
      <section>
        <b-row class="d-flex">
          <!-- 仅在PC端将这两段文本放在一起 -->
          <b-col cols="9" md="9" class="d-flex align-items-start" style="margin-top: 40px;">
            <span class="text-left custom-text">
              Find the best mobile games and apps in Appharbor, your favorite app store!
            </span>
          </b-col>
          <b-col cols="3" md="3" style="margin-top: 60px;">
            <div
              style="width: 70px;height: 16px;background-color: #D05CFA;display: flex; justify-content: center; align-items: center;">
              <a href="https://en.aptoide.com" target="_blank" rel="noopener noreferrer"
                style="text-decoration: none; color: inherit;">
                <span
                  style="font-family: PingFang SC;font-size: 10px;font-weight: 400;line-height: 12px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #fff;">
                  See All →
                </span>
              </a>
            </div>
          </b-col>
        </b-row>
      </section>
    </b-container>
    <b-container>
      <section class="row" style="margin-top: 15px;">
        <div class="col-6 col-lg-3 mb-3">
          <div class="py-1"
            style="background-color: #fff;display: flex; justify-content: center; align-items: center; flex-direction: column;">
            <img :src="first_row_1_imageUrl" alt="Punch Club 2_ Fast Forwar" class="home-image">
            <div class="d-none d-xl-block" style="margin-top: 16px;">
              <div style="display: flex; align-items: center;">
                <img :src="first_row_1_smallImageUrl" alt="Punch_Club2_Fast Forwar2">
                <div style="display: flex; flex-direction: column;width: 188px;margin-left: 15px;">
                  <div style="display: flex; align-items: center;">
                    <img src="@/assets/picture/icon_like.png" alt="icon_like">
                    <span
                      style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 6px;">
                      {{ first_row_1_likeMany }}
                    </span>
                  </div>
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-top: 3px;">
                    {{ first_row_1_title }}</span>
                </div>
              </div>
              <div style="display: flex; justify-content: space-between;margin-top: 16px; margin-bottom: 16px;">
                <div style="display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_ratings.png" alt="icon_ratings">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 8px;">
                    {{ first_row_1_score }}
                  </span>
                </div>
                <a :href="first_row_1_downloadUrl" target="_blank" style="text-decoration: none; color: inherit;">
                  <div
                    style="width: 96px;height: 28px;background: linear-gradient(100.53deg, #D55CFA 1.57%, #5D55FD 100%);border-radius: 8px;display: flex; justify-content: center; align-items: center;">
                    <span style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: center;text-underline-position: from-font;text-decoration-skip-ink: none;
                      color: #fff;">Download</span>
                  </div>
                </a>
              </div>
            </div>
            <div class="d-block d-xl-none" style="margin-top: 12px;">
              <div style="display: flex; align-items: center;">
                <img :src="first_row_1_smallImageUrl" alt="Punch_Club2_Fast Forwar2">
                <div style="display: flex; flex-direction: column;width: 110px;margin-left: 7px;">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                    {{ first_row_1_title }}
                  </span>
                </div>
              </div>
              <div style="display: flex; justify-content: space-between;margin-top: 13px;">
                <div style="display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_ratings.png" alt="icon_ratings">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 8px;">
                    {{ first_row_1_score }}
                  </span>
                </div>
                <div style="display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_like.png" alt="icon_like">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 6px;">
                    {{ first_row_1_likeMany }}
                  </span>
                </div>
              </div>
              <a :href="first_row_1_downloadUrl" target="_blank" style="text-decoration: none; color: inherit;">
                <div
                  style="width: 100%;display: flex; justify-content: center; align-items: center; flex-direction: column;">
                  <div
                    style="width: 110px;height: 28px;background: linear-gradient(100.53deg, #D55CFA 1.57%, #5D55FD 100%);border-radius: 8px;display: flex; justify-content: center; align-items: center;margin-top: 12px;margin-bottom: 8px;">
                    <span style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: center;text-underline-position: from-font;text-decoration-skip-ink: none;
                      color: #fff;">Download</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3 mb-3">
          <div class="py-1"
            style="background-color: #fff;display: flex; justify-content: center; align-items: center; flex-direction: column;">
            <img :src="first_row_2_imageUrl" alt="NFL_Retro_Bowl _25" class="home-image">
            <div class="d-none d-xl-block" style="margin-top: 16px;">
              <div style="display: flex; align-items: center;">
                <img :src="first_row_2_smallImageUrl" alt="NFL_Retro_Bowl_25_2">
                <div style="display: flex; flex-direction: column;width: 188px;margin-left: 15px;">
                  <div style="display: flex; align-items: center;">
                    <img src="@/assets/picture/icon_like.png" alt="icon_like">
                    <span
                      style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 6px;">
                      {{ first_row_2_likeMany }}
                    </span>
                  </div>
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-top: 3px;">
                    {{ first_row_2_title }}</span>
                </div>
              </div>
              <div style="display: flex; justify-content: space-between;margin-top: 16px; margin-bottom: 16px;">
                <div style="display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_ratings.png" alt="icon_ratings">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 8px;">
                    {{ first_row_2_score }}
                  </span>
                </div>
                <a :href="first_row_2_downloadUrl" target="_blank" style="text-decoration: none; color: inherit;">
                  <div
                    style="width: 96px;height: 28px;background: linear-gradient(100.53deg, #D55CFA 1.57%, #5D55FD 100%);border-radius: 8px;display: flex; justify-content: center; align-items: center;">
                    <span style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: center;text-underline-position: from-font;text-decoration-skip-ink: none;
                      color: #fff;">Download</span>
                  </div>
                </a>
              </div>
            </div>
            <div class="d-block d-xl-none" style="margin-top: 12px;">
              <div style="display: flex; align-items: center;">
                <img :src="first_row_2_smallImageUrl" alt="NFL_Retro_Bowl_25_2">
                <div style="display: flex; flex-direction: column;width: 110px;margin-left: 7px;">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                    {{ first_row_2_title }}
                  </span>
                </div>
              </div>
              <div style="display: flex; justify-content: space-between;margin-top: 13px;">
                <div style="display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_ratings.png" alt="icon_ratings">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 8px;">
                    {{ first_row_2_score }}
                  </span>
                </div>
                <div style="display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_like.png" alt="icon_like">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 6px;">
                    {{ first_row_2_likeMany }}
                  </span>
                </div>
              </div>
              <a :href="first_row_2_downloadUrl" target="_blank" style="text-decoration: none; color: inherit;">
                <div
                  style="width: 100%;display: flex; justify-content: center; align-items: center; flex-direction: column;">
                  <div
                    style="width: 110px;height: 28px;background: linear-gradient(100.53deg, #D55CFA 1.57%, #5D55FD 100%);border-radius: 8px;display: flex; justify-content: center; align-items: center;margin-top: 12px;margin-bottom: 8px;">
                    <span style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: center;text-underline-position: from-font;text-decoration-skip-ink: none;
                      color: #fff;">Download</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3 mb-3">
          <div class="py-1"
            style="background-color: #fff;display: flex; justify-content: center; align-items: center; flex-direction: column;">
            <img :src="first_row_3_imageUrl" alt="Toca Boca World" class="home-image">
            <div class="d-none d-xl-block" style="margin-top: 16px;">
              <div style="display: flex; align-items: center;">
                <img :src="first_row_3_smallImageUrl" alt="Toca_Boca_World2">
                <div style="display: flex; flex-direction: column;width: 188px;margin-left: 15px;">
                  <div style="display: flex; align-items: center;">
                    <img src="@/assets/picture/icon_like.png" alt="icon_like">
                    <span
                      style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 6px;">
                      {{ first_row_3_likeMany }}
                    </span>
                  </div>
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-top: 3px;">
                    {{ first_row_3_title }}</span>
                </div>
              </div>
              <div style="display: flex; justify-content: space-between;margin-top: 16px; margin-bottom: 16px;">
                <div style="display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_ratings.png" alt="icon_ratings">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 8px;">
                    {{ first_row_3_score }}
                  </span>
                </div>
                <a :href="first_row_3_downloadUrl" target="_blank" style="text-decoration: none; color: inherit;">
                  <div
                    style="width: 96px;height: 28px;background: linear-gradient(100.53deg, #D55CFA 1.57%, #5D55FD 100%);border-radius: 8px;display: flex; justify-content: center; align-items: center;">
                    <span style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: center;text-underline-position: from-font;text-decoration-skip-ink: none;
                      color: #fff;">Download</span>
                  </div>
                </a>
              </div>
            </div>
            <div class="d-block d-xl-none" style="margin-top: 12px;">
              <div style="display: flex; align-items: center;">
                <img :src="first_row_3_smallImageUrl" alt="Toca_Boca_World2">
                <div style="display: flex; flex-direction: column;width: 110px;margin-left: 7px;">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                    {{ first_row_1_title }}
                  </span>
                </div>
              </div>
              <div style="display: flex; justify-content: space-between;margin-top: 13px;">
                <div style="display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_ratings.png" alt="icon_ratings">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 8px;">
                    {{ first_row_3_score }}
                  </span>
                </div>
                <div style="display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_like.png" alt="icon_like">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 6px;">
                    {{ first_row_3_likeMany }}
                  </span>
                </div>
              </div>
              <a href="https://en.aptoide.com/download?package_name=com.fowgames.legendofheroes&store_name=aptoide-web&entry_point=bundle&utm_medium=home&utm_content=desktop&utm_source=web&utm_campaign=apkfy"
                style="text-decoration: none; color: inherit;">
                <div
                  style="width: 100%;display: flex; justify-content: center; align-items: center; flex-direction: column;">
                  <div
                    style="width: 110px;height: 28px;background: linear-gradient(100.53deg, #D55CFA 1.57%, #5D55FD 100%);border-radius: 8px;display: flex; justify-content: center; align-items: center;margin-top: 12px;margin-bottom: 8px;">
                    <span style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: center;text-underline-position: from-font;text-decoration-skip-ink: none;
                      color: #fff;">Download</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="col-6 col-lg-3 mb-3">
          <div class="py-1"
            style="background-color: #fff;display: flex; justify-content: center; align-items: center; flex-direction: column;">
            <img :src="first_row_4_imageUrl" alt="Crypto Conflict" class="home-image">
            <div class="d-none d-xl-block" style="margin-top: 16px;">
              <div style="display: flex; align-items: center;">
                <img :src="first_row_4_smallImageUrl" alt="Crypto_Conflict_2">
                <div style="display: flex; flex-direction: column;width: 188px;margin-left: 15px;">
                  <div style="display: flex; align-items: center;">
                    <img src="@/assets/picture/icon_like.png" alt="icon_like">
                    <span
                      style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 6px;">
                      {{ first_row_4_likeMany }}
                    </span>
                  </div>
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-top: 3px;">
                    {{ first_row_4_title }}</span>
                </div>
              </div>
              <div style="display: flex; justify-content: space-between;margin-top: 16px; margin-bottom: 16px;">
                <div style="display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_ratings.png" alt="icon_ratings">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 8px;">
                    {{ first_row_4_score }}
                  </span>
                </div>
                <a :href="first_row_4_downloadUrl" target="_blank" style="text-decoration: none; color: inherit;">
                  <div
                    style="width: 96px;height: 28px;background: linear-gradient(100.53deg, #D55CFA 1.57%, #5D55FD 100%);border-radius: 8px;display: flex; justify-content: center; align-items: center;">
                    <span style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: center;text-underline-position: from-font;text-decoration-skip-ink: none;
                      color: #fff;">Download</span>
                  </div>
                </a>
              </div>
            </div>
            <div class="d-block d-xl-none" style="margin-top: 12px;">
              <div style="display: flex; align-items: center;">
                <img :src="first_row_4_smallImageUrl" alt="Crypto_Conflict_2">
                <div style="display: flex; flex-direction: column;width: 110px;margin-left: 7px;">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                    {{ first_row_4_title }}
                  </span>
                </div>
              </div>
              <div style="display: flex; justify-content: space-between;margin-top: 13px;">
                <div style="display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_ratings.png" alt="icon_ratings">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 8px;">
                    {{ first_row_4_score }}
                  </span>
                </div>
                <div style="display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_like.png" alt="icon_like">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-left: 6px;">
                    {{ first_row_4_likeMany }}
                  </span>
                </div>
              </div>
              <a :href="first_row_4_downloadUrl" target="_blank" style="text-decoration: none; color: inherit;">
                <div
                  style="width: 100%;display: flex; justify-content: center; align-items: center; flex-direction: column;">
                  <div
                    style="width: 110px;height: 28px;background: linear-gradient(100.53deg, #D55CFA 1.57%, #5D55FD 100%);border-radius: 8px;display: flex; justify-content: center; align-items: center;margin-top: 12px;margin-bottom: 8px;">
                    <span style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: center;text-underline-position: from-font;text-decoration-skip-ink: none;
                      color: #fff;">Download</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
    </b-container>
    <b-container class="px-3 px-lg-0">
      <section>
        <h1 class="mt-3 mt-md-5"
          style="font-family: PingFang SC;font-size: 20px;font-weight: 600;line-height: 24px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
          Top Downloads This Week</h1>
      </section>
    </b-container>
    <b-container>
      <section class="row" style="margin-top: 15px;">
        <div class="col-12 col-lg-3 mb-3">
          <div class="py-1 px-2"
            style="background-color: #fff;display: flex; justify-content: space-between;border-radius: 6px;">
            <div style="display: flex; align-items: center;">
              <img :src="secondRowData[0].second_row_imageUrl" alt="Ahead_Emotions_Coach">
              <div style="display: flex; flex-direction: column; margin-left: 12px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ secondRowData[0].second_row_title }}
                </span>
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 400;line-height: 12px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-top: 5px;">
                  {{ secondRowData[0].second_row_contentText }}
                </span>
              </div>
            </div>
            <a :href="secondRowData[0].second_row_downloadUrl" target="_blank" rel="noopener noreferrer"
              style="text-decoration: none; color: inherit;">
              <div>
                <img src="@/assets/picture/icon_download.png" alt="icon_download">
              </div>
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="py-1 px-2"
            style="background-color: #fff;display: flex; justify-content: space-between;border-radius: 6px;">
            <div style="display: flex; align-items: center;">
              <img :src="secondRowData[1].second_row_imageUrl" alt="TikTok">
              <div style="display: flex; flex-direction: column; margin-left: 12px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ secondRowData[1].second_row_title }}
                </span>
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 400;line-height: 12px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-top: 5px;">
                  {{ secondRowData[1].second_row_contentText }}
                </span>
              </div>
            </div>
            <a :href="secondRowData[1].second_row_downloadUrl" target="_blank" rel="noopener noreferrer"
              style="text-decoration: none; color: inherit;">
              <div>
                <img src="@/assets/picture/icon_download.png" alt="icon_download">
              </div>
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="py-1 px-2"
            style="background-color: #fff;display: flex; justify-content: space-between;border-radius: 6px;">
            <div style="display: flex; align-items: center;">
              <img :src="secondRowData[2].second_row_imageUrl" alt="Candy_Crush_Soda_Sage">
              <div style="display: flex; flex-direction: column; margin-left: 12px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ secondRowData[2].second_row_title }}
                </span>
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 400;line-height: 12px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-top: 5px;">
                  {{ secondRowData[2].second_row_contentText }}
                </span>
              </div>
            </div>
            <a :href="secondRowData[2].second_row_downloadUrl" target="_blank" rel="noopener noreferrer"
              style="text-decoration: none; color: inherit;">
              <div>
                <img src="@/assets/picture/icon_download.png" alt="icon_download">
              </div>
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3 mt-lg-0 mb-lg-0">
          <div class="py-1 px-2"
            style="background-color: #fff;display: flex; justify-content: space-between;border-radius: 6px;">
            <div style="display: flex; align-items: center;">
              <img :src="secondRowData[3].second_row_imageUrl" alt="ELOH">
              <div style="display: flex; flex-direction: column; margin-left: 12px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ secondRowData[3].second_row_title }}
                </span>
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 400;line-height: 12px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-top: 5px;">
                  {{ secondRowData[3].second_row_contentText }}
                </span>
              </div>
            </div>
            <a :href="secondRowData[3].second_row_downloadUrl" target="_blank" rel="noopener noreferrer"
              style="text-decoration: none; color: inherit;">
              <div>
                <img src="@/assets/picture/icon_download.png" alt="icon_download">
              </div>
            </a>
          </div>
        </div>
      </section>
      <section class="row">
        <div class="col-12 col-lg-3 mb-3 mt-lg-0 mb-lg-0">
          <div class="py-1 px-2"
            style="background-color: #fff;display: flex; justify-content: space-between;border-radius: 6px;">
            <div style="display: flex; align-items: center;">
              <img :src="secondRowData[4].second_row_imageUrl" alt="Carrion">
              <div style="display: flex; flex-direction: column; margin-left: 12px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ secondRowData[4].second_row_title }}
                </span>
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 400;line-height: 12px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-top: 5px;">
                  {{ secondRowData[4].second_row_contentText }}
                </span>
              </div>
            </div>
            <a :href="secondRowData[4].second_row_downloadUrl" target="_blank" rel="noopener noreferrer"
              style="text-decoration: none; color: inherit;">
              <div>
                <img src="@/assets/picture/icon_download.png" alt="icon_download">
              </div>
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="py-1 px-2"
            style="background-color: #fff;display: flex; justify-content: space-between;border-radius: 6px;">
            <div style="display: flex; align-items: center;">
              <img :src="secondRowData[5].second_row_imageUrl" alt="Test_of_Endurance">
              <div style="display: flex; flex-direction: column; margin-left: 12px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ secondRowData[5].second_row_title }}
                </span>
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 400;line-height: 12px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-top: 5px;">
                  {{ secondRowData[5].second_row_contentText }}
                </span>
              </div>
            </div>
            <a :href="secondRowData[5].second_row_downloadUrl" target="_blank" rel="noopener noreferrer"
              style="text-decoration: none; color: inherit;">
              <div>
                <img src="@/assets/picture/icon_download.png" alt="icon_download">
              </div>
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="py-1 px-2"
            style="background-color: #fff;display: flex; justify-content: space-between;border-radius: 6px;">
            <div style="display: flex; align-items: center;">
              <img :src="secondRowData[6].second_row_imageUrl" alt="CARROT_Weather">
              <div style="display: flex; flex-direction: column; margin-left: 12px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ secondRowData[6].second_row_title }}
                </span>
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 400;line-height: 12px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-top: 5px;">
                  {{ secondRowData[6].second_row_contentText }}
                </span>
              </div>
            </div>
            <a :href="secondRowData[6].second_row_downloadUrl" target="_blank" rel="noopener noreferrer"
              style="text-decoration: none; color: inherit;">
              <div>
                <img src="@/assets/picture/icon_download.png" alt="icon_download">
              </div>
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="py-1 px-2"
            style="background-color: #fff;display: flex; justify-content: space-between;border-radius: 6px;">
            <div style="display: flex; align-items: center;">
              <img :src="secondRowData[7].second_row_imageUrl" alt="Travel_Match">
              <div style="display: flex; flex-direction: column; margin-left: 12px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ secondRowData[7].second_row_title }}
                </span>
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 400;line-height: 12px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;margin-top: 5px;">
                  {{ secondRowData[7].second_row_contentText }}
                </span>
              </div>
            </div>
            <a :href="secondRowData[7].second_row_downloadUrl" target="_blank" rel="noopener noreferrer"
              style="text-decoration: none; color: inherit;">
              <div>
                <img src="@/assets/picture/icon_download.png" alt="icon_download">
              </div>
            </a>
          </div>
        </div>
      </section>
    </b-container>
    <b-container>
      <section class="row" style="margin-top: 15px;">
        <img src="@/assets/picture/img_banner.png" alt="img_banner" class="mt-1 mt-md-5 mx-auto d-block"
          style="width: 100%; height: auto;">
      </section>
    </b-container>
    <b-container class="px-3 px-lg-0">
      <section style="margin-top: 40px;">
        <b-row class="d-flex mt-3 mt-md-5">
          <b-col cols="9" md="9" class="d-flex align-items-center">
            <h1
              style="font-family: PingFang SC;font-size: 20px;font-weight: 600;line-height: 24px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
              Games</h1>
          </b-col>
          <b-col cols="3" md="3" class="d-flex align-items-center">
            <div
              style="width: 70px;height: 16px;background-color: #D05CFA;display: flex; justify-content: center; align-items: center;">
              <a href="https://www.crazygames.com/hot" target="_blank" rel="noopener noreferrer"
                style="text-decoration: none; color: inherit;">
                <span
                  style="font-family: PingFang SC;font-size: 10px;font-weight: 400;line-height: 12px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #fff;">
                  See All →
                </span>
              </a>
            </div>
          </b-col>
        </b-row>
      </section>
    </b-container>
    <b-container>
      <section class="row" style="margin-top: 15px;">
        <div class="col-4 col-lg-1" style="display: flex; flex-direction: column;align-items: center;">
          <a :href="thirdRowData[0].third_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="border-radius: 8px;">
              <img :src="thirdRowData[0].third_row_imageUrl" alt="Bitcoin_Food_Fight">
              <div style="width: 94px;display: flex; flex-direction: column;margin-top: 8px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ thirdRowData[0].third_row_title }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-4 col-lg-1 mx-0 mx-lg-3" style="display: flex; flex-direction: column;align-items: center;">
          <a :href="thirdRowData[1].third_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="border-radius: 8px;">
              <img :src="thirdRowData[1].third_row_imageUrl" alt="Turbo_84">
              <div style="width: 94px;display: flex; flex-direction: column;margin-top: 8px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ thirdRowData[1].third_row_title }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-4 col-lg-1" style="display: flex; flex-direction: column;align-items: center;">
          <a :href="thirdRowData[2].third_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="border-radius: 8px;">
              <img :src="thirdRowData[2].third_row_imageUrl" alt="Bubble_Bash">
              <div style="width: 94px;display: flex; flex-direction: column;margin-top: 8px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ thirdRowData[2].third_row_title }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-4 col-lg-1 mx-0 mx-lg-3 mt-3 mb-3 mt-lg-0 mb-lg-0"
          style="display: flex; flex-direction: column;align-items: center;">
          <a :href="thirdRowData[3].third_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="border-radius: 8px;">
              <img :src="thirdRowData[3].third_row_imageUrl" alt="CropBytes_Farm">
              <div style="width: 94px;display: flex; flex-direction: column;margin-top: 8px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ thirdRowData[3].third_row_title }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-4 col-lg-1 mt-3 mb-3 mt-lg-0 mb-lg-0"
          style="display: flex; flex-direction: column;align-items: center;">
          <a :href="thirdRowData[4].third_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="border-radius: 8px;">
              <img :src="thirdRowData[4].third_row_imageUrl" alt="Arc8">
              <div style="width: 94px;display: flex; flex-direction: column;margin-top: 8px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ thirdRowData[4].third_row_title }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-4 col-lg-1 mx-0 mx-lg-3 mt-3 mb-3 mt-lg-0 mb-lg-0"
          style="display: flex; flex-direction: column;align-items: center;">
          <a :href="thirdRowData[5].third_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="border-radius: 8px;">
              <img :src="thirdRowData[5].third_row_imageUrl" alt="Monkey_Match_3">
              <div style="width: 94px;display: flex; flex-direction: column;margin-top: 8px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ thirdRowData[5].third_row_title }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-4 col-lg-1" style="display: flex; flex-direction: column;align-items: center;">
          <a :href="thirdRowData[6].third_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="border-radius: 8px;">
              <img :src="thirdRowData[6].third_row_imageUrl" alt="All_Games">
              <div style="width: 94px;display: flex; flex-direction: column;margin-top: 8px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ thirdRowData[6].third_row_title }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-4 col-lg-1 mx-0 mx-lg-3" style="display: flex; flex-direction: column;align-items: center;">
          <a :href="thirdRowData[7].third_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="border-radius: 8px;">
              <img :src="thirdRowData[7].third_row_imageUrl" alt="Mix_Game">
              <div style="width: 94px;display: flex; flex-direction: column;margin-top: 8px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ thirdRowData[7].third_row_title }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-4 col-lg-1" style="display: flex; flex-direction: column;align-items: center;">
          <a :href="thirdRowData[8].third_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="border-radius: 8px;">
              <img :src="thirdRowData[8].third_row_imageUrl" alt="Shiba_Inu_Eternity_Card">
              <div style="width: 94px;display: flex; flex-direction: column;margin-top: 8px;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ thirdRowData[8].third_row_title }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-4 col-lg-1 d-none d-lg-block">
          <div style="display: flex; flex-direction: column;align-items: center;margin-left: 2rem;">
            <a :href="thirdRowData[9].third_row_downloadUrl" target="_blank" rel="noopener noreferrer"
              style="text-decoration: none; color: inherit;">
              <div style="border-radius: 8px;">
                <img :src="thirdRowData[9].third_row_imageUrl" alt="Horseplay_Real_Money">
                <div style="width: 94px;display: flex; flex-direction: column;margin-top: 8px;">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 500;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                    {{ thirdRowData[9].third_row_title }}</span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </section>
    </b-container>
    <b-container class="px-3 px-lg-0">
      <section style="margin-top: 40px;">
        <b-row class="d-flex mt-3 mt-md-5">
          <b-col cols="9" md="9" class="d-flex align-items-center">
            <h1
              style="font-family: PingFang SC;font-size: 20px;font-weight: 600;line-height: 24px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
              All Apps</h1>
          </b-col>
          <b-col cols="3" md="3" class="d-flex align-items-center">
            <a href="https://play.google.com/store/apps" target="_blank" rel="noopener noreferrer"
              style="text-decoration: none; color: inherit;">
              <div
                style="width: 70px;height: 16px;background-color: #D05CFA;display: flex; justify-content: center; align-items: center;">
                <span
                  style="font-family: PingFang SC;font-size: 10px;font-weight: 400;line-height: 12px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #fff;">
                  See All →
                </span>
              </div>
            </a>
          </b-col>
        </b-row>
      </section>
    </b-container>
    <b-container>
      <section class="row" style="margin-top: 15px;">
        <div class="col-6 col-lg-2">
          <a :href="fourthRowData[0].fourth_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div
              style="display: flex; flex-direction: column;align-items: center;border-radius: 8px;background-color: #fff;">
              <img :src="fourthRowData[0].fourth_row_imageUrl" alt="Casting_Away" style="width: 100%;height: auto;">
              <div style="display: flex;align-items: center;" class="my-2">
                <img :src="fourthRowData[0].fourth_row_smallImageUrl" alt="Casting_Away2">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-left: 12px;">
                  {{ fourthRowData[0].fourth_row_title }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-6 col-lg-2">
          <a :href="fourthRowData[1].fourth_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div
              style="display: flex; flex-direction: column;align-items: center;border-radius: 8px;background-color: #fff;">
              <img :src="fourthRowData[1].fourth_row_imageUrl" alt="Thinkrolls" style="width: 100%;height: auto;">
              <div style="display: flex;align-items: center;" class="my-2">
                <img :src="fourthRowData[1].fourth_row_smallImageUrl" alt="Thinkrolls2">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-left: 12px;">
                  {{ fourthRowData[1].fourth_row_title }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-6 col-lg-2 my-3 my-lg-0">
          <a :href="fourthRowData[2].fourth_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div
              style="display: flex; flex-direction: column;align-items: center;border-radius: 8px;background-color: #fff;">
              <img :src="fourthRowData[2].fourth_row_imageUrl" alt="The_Stanley_Parable"
                style="width: 100%;height: auto;">
              <div style="display: flex;align-items: center;" class="my-2">
                <img :src="fourthRowData[2].fourth_row_smallImageUrl" alt="The_Stanley_Parable2">
                <div style="display: flex; flex-direction: column;">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-left: 12px;">
                    {{ fourthRowData[2].fourth_row_title }}</span>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="col-6 col-lg-2 my-3 my-lg-0">
          <a :href="fourthRowData[3].fourth_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div
              style="display: flex; flex-direction: column;align-items: center;border-radius: 8px;background-color: #fff;">
              <img :src="fourthRowData[3].fourth_row_imageUrl" alt="imagi" style="width: 100%;height: auto;">
              <div style="display: flex;align-items: center;" class="my-2">
                <img :src="fourthRowData[3].fourth_row_smallImageUrl" alt="imagi_2">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-left: 12px;">
                  {{ fourthRowData[3].fourth_row_title }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-6 col-lg-2">
          <a :href="fourthRowData[4].fourth_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div
              style="display: flex; flex-direction: column;align-items: center;border-radius: 8px;background-color: #fff;">
              <img :src="fourthRowData[4].fourth_row_imageUrl" alt="June’s_Journey" style="width: 100%;height: auto;">
              <div style="display: flex;align-items: center;" class="my-2">
                <img :src="fourthRowData[4].fourth_row_smallImageUrl" alt="June’s_Journey2">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-left: 12px;">
                  {{ fourthRowData[4].fourth_row_title }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="col-6 col-lg-2">
          <a :href="fourthRowData[5].fourth_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div
              style="display: flex; flex-direction: column;align-items: center;border-radius: 8px;background-color: #fff;">
              <img :src="fourthRowData[5].fourth_row_imageUrl" alt="Sololearn" style="width: 100%;height: auto;">
              <div style="display: flex;align-items: center;" class="my-2">
                <img :src="fourthRowData[5].fourth_row_smallImageUrl" alt="Sololearn2">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 14px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-left: 12px;">
                  {{ fourthRowData[5].fourth_row_title }}</span>
              </div>
            </div>
          </a>
        </div>
      </section>
    </b-container>
    <b-container class="px-3 px-lg-0">
      <section style="margin-top: 40px;">
        <b-row class="d-flex mt-3 mt-md-5">
          <b-col cols="9" md="9" class="d-flex align-items-center">
            <h1
              style="font-family: PingFang SC;font-size: 20px;font-weight: 600;line-height: 24px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
              Editorial</h1>
          </b-col>
          <b-col cols="3" md="3" class="d-flex align-items-center">
            <a href="https://www.bbc.com/watch-live-news" target="_blank" rel="noopener noreferrer"
              style="text-decoration: none; color: inherit;">
              <div
                style="width: 70px;height: 16px;background-color: #D05CFA;display: flex; justify-content: center; align-items: center;">
                <span
                  style="font-family: PingFang SC;font-size: 10px;font-weight: 400;line-height: 12px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #fff;">
                  See All →
                </span>
              </div>
            </a>
          </b-col>
        </b-row>
      </section>
    </b-container>
    <b-container>
      <section class="row" style="margin-top: 15px;">
        <div class="col-12 col-lg-3">
          <a :href="fifthRowData[0].fifth_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="border-radius: 8px;background-color: #fff;">
              <img :src="fifthRowData[0].fifth_row_imageUrl" alt="editorial1" class="d-none d-lg-block"
                style="width: 100%;height: auto;">
              <img src="@/assets/picture/Editorial_h5-1.png" alt="Editorial_h5-1" class="d-block d-lg-none"
                style="width: 100%;height: auto;">
              <div style="margin: 12px;display: flex; flex-direction: column;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ fifthRowData[0].fifth_row_title }}</span>
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 400;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-top: 6px;">
                  {{ fifthRowData[0].fifth_row_contentText }}</span>
                <div style="display: flex; justify-content: space-between;margin-top: 12px;margin-bottom: 12px;">
                  <span
                    style="font-family: PingFang SC;font-size: 12px;font-weight: 400;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;">
                    {{ fifthRowData[0].fifth_row_likeMany }}</span>
                  <span
                    style="font-family: PingFang SC;font-size: 12px;font-weight: 400;line-height: 15px;text-align: right;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;">
                    {{ fifthRowData[0].fifth_row_recordDate }}</span>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="col-12 col-lg-3">
          <a :href="fifthRowData[1].fifth_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="border-radius: 8px;background-color: #fff;">
              <img :src="fifthRowData[1].fifth_row_imageUrl" alt="editorial2" class="d-none d-lg-block"
                style="width: 100%;height: auto;">
              <img src="@/assets/picture/Editorial_h5-2.png" alt="Editorial_h5-2" class="d-block d-lg-none"
                style="width: 100%;height: auto;">
              <div style="margin: 12px;display: flex; flex-direction: column;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ fifthRowData[1].fifth_row_title }}</span>
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 400;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-top: 6px;">
                  {{ fifthRowData[1].fifth_row_contentText }}</span>
                <div style="display: flex; justify-content: space-between;margin-top: 12px;margin-bottom: 12px;">
                  <span
                    style="font-family: PingFang SC;font-size: 12px;font-weight: 400;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;">
                    {{ fifthRowData[1].fifth_row_likeMany }}</span>
                  <span
                    style="font-family: PingFang SC;font-size: 12px;font-weight: 400;line-height: 15px;text-align: right;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;">
                    {{ fifthRowData[1].fifth_row_recordDate }}</span>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="col-12 col-lg-3">
          <a :href="fifthRowData[2].fifth_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="border-radius: 8px;background-color: #fff;">
              <img :src="fifthRowData[2].fifth_row_imageUrl" alt="editorial3" class="d-none d-lg-block"
                style="width: 100%;height: auto;">
              <img src="@/assets/picture/Editorial_h5-3.png" alt="Editorial_h5-3" class="d-block d-lg-none"
                style="width: 100%;height: auto;">
              <div style="margin: 12px;display: flex; flex-direction: column;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ fifthRowData[2].fifth_row_title }}</span>
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 400;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-top: 6px;">
                  {{ fifthRowData[2].fifth_row_contentText }}</span>
                <div style="display: flex; justify-content: space-between;margin-top: 12px;margin-bottom: 12px;">
                  <span
                    style="font-family: PingFang SC;font-size: 12px;font-weight: 400;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;">
                    {{ fifthRowData[2].fifth_row_likeMany }}</span>
                  <span
                    style="font-family: PingFang SC;font-size: 12px;font-weight: 400;line-height: 15px;text-align: right;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;">
                    {{ fifthRowData[2].fifth_row_recordDate }}</span>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="col-12 col-lg-3">
          <a :href="fifthRowData[3].fifth_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="border-radius: 8px;background-color: #fff;">
              <img :src="fifthRowData[3].fifth_row_imageUrl" alt="editorial4" class="d-none d-lg-block"
                style="width: 100%;height: auto;">
              <img src="@/assets/picture/Editorial_h5-4 Tiktok.png" alt="Editorial_h5-4 Tiktok"
                class="d-block d-lg-none" style="width: 100%;height: auto;">
              <div style="margin: 12px;display: flex; flex-direction: column;">
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                  {{ fifthRowData[3].fifth_row_title }}</span>
                <span
                  style="font-family: PingFang SC;font-size: 14px;font-weight: 400;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-top: 6px;">
                  {{ fifthRowData[3].fifth_row_contentText }}</span>
                <div style="display: flex; justify-content: space-between;margin-top: 12px;margin-bottom: 12px;">
                  <span
                    style="font-family: PingFang SC;font-size: 12px;font-weight: 400;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;">
                    {{ fifthRowData[3].fifth_row_likeMany }}</span>
                  <span
                    style="font-family: PingFang SC;font-size: 12px;font-weight: 400;line-height: 15px;text-align: right;text-underline-position: from-font;text-decoration-skip-ink: none;color: #00000073;">
                    {{ fifthRowData[3].fifth_row_recordDate }}</span>
                </div>
              </div>
            </div>
          </a>
        </div>
      </section>
    </b-container>
    <b-container class="px-3 px-lg-0">
      <section style="margin-top: 40px;">
        <b-row class="d-flex mt-3 mt-md-5">
          <b-col cols="9" md="9" class="d-flex align-items-center">
            <h1
              style="font-family: PingFang SC;font-size: 20px;font-weight: 600;line-height: 24px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
              Live Channel</h1>
          </b-col>
        </b-row>
      </section>
    </b-container>
    <b-container>
      <section class="row pb-3" style="margin-top: 15px;">
        <div class="col-12 col-lg-4 mb-3">
          <a :href="sixRowData[0].six_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="padding: 8px;background-color: #fff;border-radius: 8px; display: flex; align-items: center;">
              <img :src="sixRowData[0].six_row_imageUrl" alt="Live_Channel12">
              <div style="display: flex; flex-direction: column;margin-left: 12px;height: 108px;">
                <div style="flex: 1;display: flex; align-items: center;">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                    {{sixRowData[0].six_row_title }}</span>
                </div>
                <div style="flex: 1;display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_eye-filled.png" alt="icon_eye-filled">
                  <span
                    style="font-family: Poppins;font-size: 14px;font-weight: 400;line-height: 14px;text-align: center;text-underline-position: from-font;text-decoration-skip-ink: none;margin-left: 8px;">
                    {{sixRowData[0].six_row_likeMany }}</span>
                </div>
                <div style="flex: 1;display: flex; align-items: center;">
                  <img :src="sixRowData[0].six_row_smallImageUrl" alt="img_user">
                  <span
                    style="font-family: Poppins;font-size: 14px;font-weight: 500;line-height: 21px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-left: 8px;">
                    {{sixRowData[0].six_row_contentText }}</span>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="col-12 col-lg-4 mb-3">
          <a :href="sixRowData[1].six_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="padding: 8px;background-color: #fff;border-radius: 8px; display: flex; align-items: center;">
              <img :src="sixRowData[1].six_row_imageUrl" alt="Live_Channel11">
              <div style="display: flex; flex-direction: column;margin-left: 12px;height: 108px;">
                <div style="flex: 1;display: flex; align-items: center;">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                    {{sixRowData[1].six_row_title }}</span>
                </div>
                <div style="flex: 1;display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_eye-filled.png" alt="icon_eye-filled">
                  <span
                    style="font-family: Poppins;font-size: 14px;font-weight: 400;line-height: 14px;text-align: center;text-underline-position: from-font;text-decoration-skip-ink: none;margin-left: 8px;">
                    {{sixRowData[1].six_row_likeMany }}</span>
                </div>
                <div style="flex: 1;display: flex; align-items: center;">
                  <img :src="sixRowData[1].six_row_smallImageUrl" alt="img_user">
                  <span
                    style="font-family: Poppins;font-size: 14px;font-weight: 500;line-height: 21px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-left: 8px;">
                    {{sixRowData[1].six_row_contentText }}</span>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="col-12 col-lg-4 mb-3">
          <a :href="sixRowData[2].six_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="padding: 8px;background-color: #fff;border-radius: 8px; display: flex; align-items: center;">
              <img :src="sixRowData[2].six_row_imageUrl" alt="Live_Channel8">
              <div style="display: flex; flex-direction: column;margin-left: 12px;height: 108px;">
                <div style="flex: 1;display: flex; align-items: center;">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                    {{sixRowData[2].six_row_title }}</span>
                </div>
                <div style="flex: 1;display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_eye-filled.png" alt="icon_eye-filled">
                  <span
                    style="font-family: Poppins;font-size: 14px;font-weight: 400;line-height: 14px;text-align: center;text-underline-position: from-font;text-decoration-skip-ink: none;margin-left: 8px;">
                    {{sixRowData[2].six_row_likeMany }}</span>
                </div>
                <div style="flex: 1;display: flex; align-items: center;">
                  <img :src="sixRowData[2].six_row_smallImageUrl" alt="img_user">
                  <span
                    style="font-family: Poppins;font-size: 14px;font-weight: 500;line-height: 21px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-left: 8px;">
                    {{sixRowData[2].six_row_contentText }}</span>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="col-12 col-lg-4 d-block d-lg-none">
          <a :href="sixRowData[3].six_row_downloadUrl" target="_blank" rel="noopener noreferrer"
            style="text-decoration: none; color: inherit;">
            <div style="padding: 8px;background-color: #fff;border-radius: 8px; display: flex; align-items: center;">
              <img :src="sixRowData[3].six_row_imageUrl" alt="Live_Channel7">
              <div style="display: flex; flex-direction: column;margin-left: 12px;height: 108px;">
                <div style="flex: 1;display: flex; align-items: center;">
                  <span
                    style="font-family: PingFang SC;font-size: 14px;font-weight: 600;line-height: 15px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;">
                    {{sixRowData[3].six_row_title }}</span>
                </div>
                <div style="flex: 1;display: flex; align-items: center;">
                  <img src="@/assets/picture/icon_eye-filled.png" alt="icon_eye-filled">
                  <span
                    style="font-family: Poppins;font-size: 14px;font-weight: 400;line-height: 14px;text-align: center;text-underline-position: from-font;text-decoration-skip-ink: none;margin-left: 8px;">
                    {{sixRowData[3].six_row_likeMany }}</span>
                </div>
                <div style="flex: 1;display: flex; align-items: center;">
                  <img :src="sixRowData[3].six_row_smallImageUrl" alt="img_user">
                  <span
                    style="font-family: Poppins;font-size: 14px;font-weight: 500;line-height: 21px;text-align: left;text-underline-position: from-font;text-decoration-skip-ink: none;margin-left: 8px;">
                    {{sixRowData[3].six_row_contentText }}</span>
                </div>
              </div>
            </div>
          </a>
        </div>
      </section>
    </b-container>
  </div>
</template>

<script>
import { BContainer, BRow, BCol } from 'bootstrap-vue-next';

export default {
  name: 'HomeView',
  components: {
    BContainer,
    BRow,
    BCol
  },
  data() {
    return {
      items: ['Windows', 'Android', 'Mac', 'iPhone'],
      activeIndex: 0,
      items2: ['Windows', 'Android', 'Mac', 'iPhone'],
      activeIndex2: 0,
      leftBanner: '',
      rightBanner: '',
      banner_middle: '',
      first_row_1_title: '',
      first_row_1_imageUrl: '',
      first_row_1_smallImageUrl: '',
      first_row_1_likeMany: '',
      first_row_1_score: '',
      first_row_1_downloadUrl: '',
      first_row_2_title: '',
      first_row_2_imageUrl: '',
      first_row_2_smallImageUrl: '',
      first_row_2_likeMany: '',
      first_row_2_score: '',
      first_row_2_downloadUrl: '',
      first_row_3_title: '',
      first_row_3_imageUrl: '',
      first_row_3_smallImageUrl: '',
      first_row_3_likeMany: '',
      first_row_3_score: '',
      first_row_3_downloadUrl: '',
      first_row_4_title: '',
      first_row_4_imageUrl: '',
      first_row_4_smallImageUrl: '',
      first_row_4_likeMany: '',
      first_row_4_score: '',
      first_row_4_downloadUrl: '',
      secondRowData: Array.from({ length: 8 }, () => ({
        second_row_title: '',
        second_row_imageUrl: '',
        second_row_contentText: '',
        second_row_downloadUrl: ''
      })),
      thirdRowData: Array.from({ length: 10 }, () => ({
        third_row_title: '',
        third_row_imageUrl: '',
        third_row_downloadUrl: ''
      })),
      fourthRowData: Array.from({ length: 6 }, () => ({
        fourth_row_title: '',
        fourth_row_imageUrl: '',
        fourth_row_smallImageUrl: '',
        fourth_row_downloadUrl: ''
      })),
      fifthRowData: Array.from({ length: 4 }, () => ({
        fifth_row_title: '',
        fifth_row_imageUrl: '',
        fifth_row_contentText: '',
        fifth_row_likeMany: '',
        fifth_row_recordDate: '',
        fifth_row_downloadUrl: ''
      })),
      sixRowData: Array.from({ length: 4 }, () => ({
        six_row_title: '',
        six_row_imageUrl: '',
        six_row_likeMany: '',
        six_row_downloadUrl: '',
        six_row_smallImageUrl: '',
        six_row_contentText: '',
      })),
    };
  },
  methods: {
    waitForImagesToLoad() {
      const images = document.querySelectorAll('img'); // 获取所有图片
      let loadedCount = 0;

      // 检查图片是否存在
      if (!images.length) {
        console.warn('No images found to adjust positions.');
        this.adjustSidePositions(); // 即使没有图片也调整布局
        return;
      }

      images.forEach(img => {
        if (img.complete) {
          // 图片已经加载完成
          loadedCount++;
        } else {
          // 监听图片加载完成事件
          img.addEventListener('load', () => {
            loadedCount++;
            if (loadedCount === images.length) {
              console.log('All images loaded.');
              this.adjustSidePositions(); // 调整位置
            }
          });

          // 监听图片加载失败事件
          img.addEventListener('error', () => {
            console.error(`Image failed to load: ${img.src}`);
            loadedCount++;
            if (loadedCount === images.length) {
              this.adjustSidePositions(); // 调整位置
            }
          });
        }
      });

      // 如果所有图片已经加载完成，直接调整位置
      if (loadedCount === images.length) {
        console.log('Images were already loaded.');
        this.adjustSidePositions();
      }
    },

    adjustSidePositions() {
      const container = document.querySelector('.container');
      const leftSide = document.querySelector('.side.left');
      const rightSide = document.querySelector('.side.right');
      if (!container) {
        console.error('Container element not found.');
        return;
      }
      if (!leftSide || !rightSide) {
        console.error('Side elements not found.');
        return;
      }
      // 获取中间内容的位置和宽度
      const containerRect = container.getBoundingClientRect();
      const containerLeft = containerRect.left;
      const containerRight = containerRect.right;
      // 设置左右内容的位置
      leftSide.style.left = `${containerLeft - leftSide.offsetWidth - 10}px`;
      rightSide.style.left = `${containerRight + 10}px`;
      console.log('Side positions adjusted:', {
        left: leftSide.style.left,
        right: rightSide.style.left
      });
    }
  },
  mounted() {
    // 设置页面标题
    document.title = 'App Download Platform - Download Your Favorite Apps';

    // 调整位置（初始调用）
    this.$nextTick(() => {
      this.adjustSidePositions();
    });

    // 在所有资源加载完成后再调整位置
    window.onload = () => {
      this.adjustSidePositions();
    };

    // 监听窗口大小变化
    window.addEventListener('resize', this.adjustSidePositions);

    // 加载广告数据
    fetch('https://uptodown.life/system/advertiseContent/contentList?areaId=1')
      .then(response => response.json())
      .then(data => {
        const getImageUrlByPageId = (data, pageId) => {
          const item = data.find(entry => entry.pageId === pageId);
          return item ? item.imageUrl : null;
        };

        this.leftBanner = getImageUrlByPageId(data, 'banner_left');
        this.rightBanner = getImageUrlByPageId(data, 'banner_right');
        this.banner_middle = getImageUrlByPageId(data, 'banner_middle');

        // 等图片加载完成后调整位置
        this.$nextTick(() => {
          this.waitForImagesToLoad();
        });
      })
      .catch(error => {
        console.error('Error fetching banner images:', error);
      });
    fetch('https://uptodown.life/system/advertiseContent/contentList?areaId=3')
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          data.forEach((item, index) => {
            this[`first_row_${index + 1}_title`] = item.title || ``;
            this[`first_row_${index + 1}_imageUrl`] = item.imageUrl || '';
            this[`first_row_${index + 1}_smallImageUrl`] = item.smallImageUrl || '';
            this[`first_row_${index + 1}_likeMany`] = item.likeMany || '';
            this[`first_row_${index + 1}_score`] = item.score || '';
            this[`first_row_${index + 1}_downloadUrl`] = item.downloadUrl || '';
          });
        } else {
          console.warn('数据为空或格式不正确');
        }
      })
      .catch(error => {
        console.error('Error fetching banner images:', error);
      });
    fetch('https://uptodown.life/system/advertiseContent/contentList?areaId=4')
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          this.secondRowData = data.map(item => ({
            second_row_title: item.title || '',
            second_row_imageUrl: item.imageUrl || '',
            second_row_contentText: item.contentText || '',
            second_row_downloadUrl: item.downloadUrl || '',
          }));
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
    fetch('https://uptodown.life/system/advertiseContent/contentList?areaId=5')
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          this.thirdRowData = data.map(item => ({
            third_row_title: item.title || '',
            third_row_imageUrl: item.imageUrl || '',
            third_row_downloadUrl: item.downloadUrl || '',
          }));
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
    fetch('https://uptodown.life/system/advertiseContent/contentList?areaId=6')
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          this.fourthRowData = data.map(item => ({
            fourth_row_title: item.title || '',
            fourth_row_imageUrl: item.imageUrl || '',
            fourth_row_smallImageUrl: item.smallImageUrl || '',
            fourth_row_downloadUrl: item.downloadUrl || '',
          }));
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
    fetch('https://uptodown.life/system/advertiseContent/contentList?areaId=7')
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          this.fifthRowData = data.map(item => ({
            fifth_row_title: item.title || '',
            fifth_row_imageUrl: item.imageUrl || '',
            fifth_row_contentText: item.contentText || '',
            fifth_row_likeMany: item.likeMany || '',
            fifth_row_recordDate: item.recordDate || '',
            fifth_row_downloadUrl: item.downloadUrl || '',
          }));
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
    fetch('https://uptodown.life/system/advertiseContent/contentList?areaId=8')
      .then(response => response.json())
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          this.sixRowData = data.map(item => ({
            six_row_title: item.title || '',
            six_row_imageUrl: item.imageUrl || '',
            six_row_likeMany: item.likeMany || '',
            six_row_downloadUrl: item.downloadUrl || '',
            six_row_smallImageUrl: item.smallImageUrl || '',
            six_row_contentText: item.contentText || '',
          }));
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  },
  beforeUnmount() {
    // 移除事件监听器，避免内存泄漏
    window.removeEventListener('resize', this.adjustSidePositions);
    window.onload = null; // 清除 onload 事件
  },
  waitForImagesToLoad() {
    const images = document.querySelectorAll('img'); // 获取所有图片
    let loadedCount = 0; // 已加载图片计数

    images.forEach(img => {
      if (img.complete) {
        // 如果图片已经加载完成
        loadedCount++;
      } else {
        // 监听图片加载完成事件
        img.addEventListener('load', () => {
          loadedCount++;
          if (loadedCount === images.length) {
            this.adjustSidePositions(); // 调整位置
          }
        });

        // 如果加载失败，也增加计数
        img.addEventListener('error', () => {
          loadedCount++;
          if (loadedCount === images.length) {
            this.adjustSidePositions(); // 调整位置
          }
        });
      }
    });

    // 如果所有图片已经加载完成，直接调整位置
    if (loadedCount === images.length) {
      this.adjustSidePositions();
    }
  },
};
</script>


<style scoped>
/* 使用媒体查询，根据不同屏幕尺寸设置图片大小 */
.home-image {
  max-width: 100%;
  height: auto;
  /* 保持等比例缩放 */
}

/* 针对手机端（max-width: 767px）设置图片最大宽度 */
@media (max-width: 767px) {
  .home-image {
    width: 88%;
    /* 可以根据需求调整 */
  }
}

/* 针对平板和PC端（min-width: 768px）设置图片最大宽度 */
@media (min-width: 768px) {
  .home-image {
    width: 97%;
    /* 可以根据需求调整 */
  }
}

.container {
  position: relative;
  display: inline-block;
  /* 使中间内容宽度根据内容自适应 */
}

.side {
  position: fixed;
  /* 固定位置 */
  top: 50%;
  /* 垂直居中 */
  transform: translateY(-50%);
  /* 调整垂直方向完全居中 */
}

.side.left {
  margin-right: 10px;
  /* 与中间内容保持一定间距 */
}

.side.right {
  margin-left: 10px;
  /* 与中间内容保持一定间距 */
}
</style>
